module.exports = __webpack_public_path__ + "static/img/about_us.17117c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_us.png
// module id = 1pqF
// module chunks = 0